// extracted by mini-css-extract-plugin
export default {"landing":"search-landing_landing__0gfYu"};